var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * ArrowDownAlt component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconArrowDownAlt extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.5 2.72006C12.5 2.32238 12.1642 2 11.75 2C11.3358 2 11 2.32238 11 2.72006V19.9393L7.28033 16.2197C6.98744 15.9268 6.51256 15.9268 6.21967 16.2197C5.92678 16.5126 5.92678 16.9874 6.21967 17.2803L11.1439 22.2046C11.4368 22.4975 11.9117 22.4975 12.2046 22.2046L17.1288 17.2803C17.4217 16.9874 17.4217 16.5126 17.1288 16.2197C16.8359 15.9268 16.361 15.9268 16.0681 16.2197L12.5 19.7878V2.72006Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconArrowDownAlt.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowDownAlt.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconArrowDownAlt.prototype, "size", void 0);
if (customElements.get('cat-icon-arrow-down-alt') === undefined) {
    customElements.define('cat-icon-arrow-down-alt', BlocksIconArrowDownAlt);
}
